import Parchment from 'parchment.js';
import { ColorAttributor } from './color.js';

let BackgroundClass = new Parchment.Attributor.Class('background', 'ql-bg', {
  scope: Parchment.Scope.INLINE
});
let BackgroundStyle = new ColorAttributor('background', 'background-color', {
  scope: Parchment.Scope.INLINE
});

export { BackgroundClass, BackgroundStyle };



// WEBPACK FOOTER //
// ./formats/background.js